<ion-grid>
  <ion-row class="ion-align-items-center">
    <ion-col><ion-searchbar [(ngModel)]="szuro" placeholder="Keresés név, email, telefon…"></ion-searchbar></ion-col>
    <ion-col size="auto">
      <input #jubFile type="file" accept="application/pdf,.pdf" hidden (change)="jubPdfValaszt($event)" />
      <ion-button fill="outline" [disabled]="jubFeldolgozas" (click)="jubFile.click()">
        <ion-spinner *ngIf="jubFeldolgozas" slot="start" name="crescent"></ion-spinner>
        <ion-icon *ngIf="!jubFeldolgozas" slot="start" name="document-attach"></ion-icon>JÜB fájl (PDF)
      </ion-button>
    </ion-col>
    <ion-col size="auto">
      <input #jubZip type="file" accept=".zip,application/zip" hidden (change)="jubBulk($event)" />
      <ion-button fill="outline" color="tertiary" [disabled]="jubFeldolgozas" (click)="jubZip.click()">
        <ion-icon slot="start" name="albums"></ion-icon>Tömeges (ZIP)
      </ion-button>
    </ion-col>
    <ion-col size="auto"><ion-button (click)="uj()"><ion-icon slot="start" name="person-add"></ion-icon>Új személy</ion-button></ion-col>
  </ion-row>
</ion-grid>

<ion-list lines="full">
  <ion-item *ngIf="szurtSzemelyek.length === 0"><ion-label color="medium">Nincs megjeleníthető személy.</ion-label></ion-item>
  <ion-item button *ngFor="let s of szurtSzemelyek" (click)="megnyit(s)">
    <ion-icon slot="start" [name]="ikon(s.tipus)" color="primary"></ion-icon>
    <ion-label>
      <h2>{{ s.nev }}</h2>
      <p>{{ cimke(opciok.szemelyTipus, s.tipus) }}<span *ngIf="s.telefon"> · {{ s.telefon }}</span><span *ngIf="s.email"> · {{ s.email }}</span></p>
    </ion-label>
    <ion-button slot="end" fill="clear" color="danger" (click)="$event.stopPropagation(); torol(s)"><ion-icon name="trash"></ion-icon></ion-button>
  </ion-item>
</ion-list>

<ion-modal #szemelyModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ szerk?.id ? szerk.nev : 'Új személy' }}</ion-title>
        <ion-buttons slot="end"><ion-button (click)="szemelyModal.dismiss()">Bezár</ion-button></ion-buttons>
      </ion-toolbar>
      <ion-toolbar color="light" *ngIf="szerk?.id">
        <ion-segment scrollable [(ngModel)]="segment">
          <ion-segment-button value="adatok"><ion-label>Adatok</ion-label></ion-segment-button>
          <ion-segment-button value="cimek"><ion-label>Címek</ion-label></ion-segment-button>
          <ion-segment-button value="okmanyok"><ion-label>Okmányok</ion-label></ion-segment-button>
          <ion-segment-button value="jub"><ion-label>JÜB</ion-label></ion-segment-button>
          <ion-segment-button value="ugyek"><ion-label>Ügyek</ion-label></ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">

      <!-- ADATOK -->
      <div *ngIf="segment === 'adatok'">
        <ion-list>
          <ion-item>
            <ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="szerk.tipus" interface="popover">
              <ion-select-option *ngFor="let o of opciok.szemelyTipus" [value]="o.value">{{ o.label }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item><ion-input label="Név *" labelPlacement="stacked" [(ngModel)]="szerk.nev" (ionInput)="nevValtozott()"></ion-input></ion-item>

          <ion-card *ngIf="hasonloak.length" color="warning">
            <ion-card-header><ion-card-subtitle>Hasonló nevű személy már létezik – lehet, hogy ugyanaz?</ion-card-subtitle></ion-card-header>
            <ion-list>
              <ion-item button *ngFor="let h of hasonloak" (click)="megnyit(h)">
                <ion-label>{{ h.nev }} <span *ngIf="h.szuletesi_ido">({{ h.szuletesi_ido }})</span></ion-label>
              </ion-item>
            </ion-list>
          </ion-card>

          <ng-container *ngIf="szerk.tipus === 'termeszetes'">
            <ion-item><ion-input label="Születési név" labelPlacement="stacked" [(ngModel)]="szerk.szuletesi_nev"></ion-input></ion-item>
            <ion-item><ion-input label="Születési hely" labelPlacement="stacked" [(ngModel)]="szerk.szuletesi_hely"></ion-input></ion-item>
            <ion-item><ion-input type="date" label="Születési idő" labelPlacement="stacked" [(ngModel)]="szerk.szuletesi_ido"></ion-input></ion-item>
            <ion-item><ion-input label="Anyja neve" labelPlacement="stacked" [(ngModel)]="szerk.anyja_neve"></ion-input></ion-item>
            <ion-item><ion-input label="Személyi azonosító" labelPlacement="stacked" [(ngModel)]="szerk.szemelyi_szam"></ion-input></ion-item>
            <ion-item><ion-input label="Adóazonosító jel" labelPlacement="stacked" [(ngModel)]="szerk.adoazonosito"></ion-input></ion-item>
            <ion-item><ion-input label="Állampolgárság" labelPlacement="stacked" [(ngModel)]="szerk.allampolgarsag"></ion-input></ion-item>
          </ng-container>

          <ng-container *ngIf="szerk.tipus !== 'termeszetes'">
            <ion-item><ion-input label="Adószám" labelPlacement="stacked" [(ngModel)]="szerk.adoszam"></ion-input></ion-item>
            <ion-item><ion-input label="Cégjegyzékszám" labelPlacement="stacked" [(ngModel)]="szerk.cegjegyzekszam"></ion-input></ion-item>
            <ion-item><ion-input label="Statisztikai szám" labelPlacement="stacked" [(ngModel)]="szerk.statisztikai_szam"></ion-input></ion-item>
            <ion-item><ion-input label="Nyilvántartási szám" labelPlacement="stacked" [(ngModel)]="szerk.nyilvantartasi_szam"></ion-input></ion-item>
            <ion-item><ion-input label="Képviselő / ügyvezető" labelPlacement="stacked" [(ngModel)]="szerk.ugyvezeto"></ion-input></ion-item>
          </ng-container>

          <ion-item><ion-input type="email" label="E-mail" labelPlacement="stacked" [(ngModel)]="szerk.email"></ion-input></ion-item>
          <ion-item><ion-input label="Telefon" labelPlacement="stacked" [(ngModel)]="szerk.telefon"></ion-input></ion-item>
          <ion-item>
            <ion-checkbox slot="start" [(ngModel)]="szerk.formazas_tiltva"></ion-checkbox>
            <ion-label>Formázás tiltása (külföldi azonosítók)</ion-label>
          </ion-item>
          <ion-item><ion-textarea label="Megjegyzés" labelPlacement="stacked" autoGrow="true" [(ngModel)]="szerk.megjegyzes"></ion-textarea></ion-item>
        </ion-list>
        <ion-button expand="block" (click)="mentes()">{{ szerk.id ? 'Mentés' : 'Létrehozás' }}</ion-button>
        <ion-note *ngIf="!szerk.id" class="ion-padding-start" color="medium">A címeket, okmányokat és JÜB-et a mentés után tudod rögzíteni.</ion-note>
      </div>

      <!-- CÍMEK -->
      <div *ngIf="segment === 'cimek'">
        <ion-list lines="full">
          <ion-item *ngFor="let c of reszletek.cimek">
            <ion-label><h3>{{ cimke(opciok.cimTipus, c.tipus) }} <ion-badge *ngIf="c.alapertelmezett">alap</ion-badge></h3><p>{{ c.cim }}</p></ion-label>
            <ion-button slot="end" fill="clear" color="danger" (click)="cimTorol(c.id)"><ion-icon name="trash"></ion-icon></ion-button>
          </ion-item>
        </ion-list>
        <ion-list>
          <ion-item>
            <ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ujCim.tipus" interface="popover">
              <ion-select-option *ngFor="let o of opciok.cimTipus" [value]="o.value">{{ o.label }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item><ion-input label="Cím" labelPlacement="stacked" [(ngModel)]="ujCim.cim"></ion-input></ion-item>
          <ion-item><ion-checkbox slot="start" [(ngModel)]="ujCim.alapertelmezett"></ion-checkbox><ion-label>Alapértelmezett</ion-label></ion-item>
        </ion-list>
        <ion-button expand="block" (click)="cimHozzaad()">Cím hozzáadása</ion-button>
      </div>

      <!-- OKMÁNYOK -->
      <div *ngIf="segment === 'okmanyok'">
        <ion-list lines="full">
          <ion-item *ngFor="let o of reszletek.okmanyok">
            <ion-label><h3>{{ cimke(opciok.okmanyTipus, o.tipus) }} <ion-badge *ngIf="o.archivalt" color="medium">archivált</ion-badge></h3>
              <p>{{ o.szam }}<span *ngIf="o.ervenyesseg"> · érv.: {{ o.ervenyesseg }}</span></p></ion-label>
            <ion-button slot="end" fill="clear" color="danger" (click)="okmanyTorol(o.id)"><ion-icon name="trash"></ion-icon></ion-button>
          </ion-item>
        </ion-list>
        <ion-list>
          <ion-item>
            <ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ujOkmany.tipus" interface="popover">
              <ion-select-option *ngFor="let o of opciok.okmanyTipus" [value]="o.value">{{ o.label }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item><ion-input label="Okmányszám" labelPlacement="stacked" [(ngModel)]="ujOkmany.szam"></ion-input></ion-item>
          <ion-item><ion-input type="date" label="Érvényesség" labelPlacement="stacked" [(ngModel)]="ujOkmany.ervenyesseg"></ion-input></ion-item>
        </ion-list>
        <ion-button expand="block" (click)="okmanyHozzaad()">Okmány hozzáadása</ion-button>
      </div>

      <!-- JÜB -->
      <div *ngIf="segment === 'jub'">
        <input #jubFileSzemely type="file" accept="application/pdf,.pdf" hidden (change)="jubPdfSzemelyhez($event)" />
        <ion-button expand="block" fill="outline" [disabled]="jubFeldolgozas" (click)="jubFileSzemely.click()">
          <ion-spinner *ngIf="jubFeldolgozas" slot="start" name="crescent"></ion-spinner>
          <ion-icon *ngIf="!jubFeldolgozas" slot="start" name="document-attach"></ion-icon>JÜB fájl feltöltése (PDF, adatkiolvasás)
        </ion-button>
        <ion-list lines="full">
          <ion-item *ngFor="let j of reszletek.jub">
            <ion-icon slot="start" name="shield-checkmark" color="primary"></ion-icon>
            <ion-label><h3>{{ j.azonosito || '(azonosító nélkül)' }}</h3><p>{{ j.datum }}<span *ngIf="j.eredeti_nev"> · {{ j.eredeti_nev }}</span></p></ion-label>
            <ion-button *ngIf="j.pdf_objektum" slot="end" fill="clear" (click)="jubMegnyit(j, 'pdf')" title="Megnyitás"><ion-icon name="document-text"></ion-icon></ion-button>
            <ion-button *ngIf="j.eredeti_objektum && j.eredeti_objektum !== j.pdf_objektum" slot="end" fill="clear" color="medium" (click)="jubMegnyit(j, 'eredeti')" title="Eredeti fájl"><ion-icon name="ribbon"></ion-icon></ion-button>
            <ion-button slot="end" fill="clear" color="danger" (click)="jubTorol(j.id)"><ion-icon name="trash"></ion-icon></ion-button>
          </ion-item>
        </ion-list>
        <ion-list>
          <ion-item><ion-input type="date" label="Ellenőrzés dátuma" labelPlacement="stacked" [(ngModel)]="ujJub.datum"></ion-input></ion-item>
          <ion-item><ion-input label="JÜB azonosító" labelPlacement="stacked" [(ngModel)]="ujJub.azonosito"></ion-input></ion-item>
          <ion-item><ion-textarea label="Nyers adat (beillesztés)" labelPlacement="stacked" autoGrow="true" [(ngModel)]="ujJub.nyers"></ion-textarea></ion-item>
        </ion-list>
        <ion-button expand="block" (click)="jubHozzaad()">JÜB rögzítése</ion-button>
      </div>

      <!-- KAPCSOLÓDÓ ÜGYEK -->
      <div *ngIf="segment === 'ugyek'">
        <ion-list lines="full">
          <ion-item *ngIf="reszletek.ugyek.length === 0"><ion-label color="medium">Nincs kapcsolódó ügy.</ion-label></ion-item>
          <ion-item button *ngFor="let u of reszletek.ugyek" [routerLink]="['/caesar/ugy', u.id]" (click)="szemelyModal.dismiss()">
            <ion-icon slot="start" name="briefcase" color="primary"></ion-icon>
            <ion-label><h3>{{ u.ugyazonosito }} — {{ u.leiras }}</h3><p>{{ u.szerep }}<span *ngIf="u.sajat_ugyfel"> · saját ügyfél</span></p></ion-label>
          </ion-item>
        </ion-list>
      </div>

    </ion-content>
  </ng-template>
</ion-modal>

<!-- JÜB PDF előnézet -->
<ion-modal #jubPdfModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>JÜB adatok a PDF-ből</ion-title>
        <ion-buttons slot="end"><ion-button (click)="jubPdfModal.dismiss()">Mégse</ion-button></ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" *ngIf="jubParsed">
      <ion-note color="medium">Ellenőrizd az adatokat. A feltöltött PDF a személyhez tárolódik.</ion-note>
      <ion-card *ngIf="jubFigyelmeztetes" color="warning" class="ion-margin-top">
        <ion-card-content><ion-icon name="warning" style="vertical-align:middle"></ion-icon> {{ jubFigyelmeztetes }}</ion-card-content>
      </ion-card>

      <!-- Cél: új vagy meglévő személy -->
      <ion-radio-group [(ngModel)]="jubCel" class="ion-margin-top">
        <ion-list-header><ion-label>Hová mentsük?</ion-label></ion-list-header>
        <ion-item *ngIf="jubTalalat">
          <ion-radio slot="start" value="meglevo"></ion-radio>
          <ion-label>Meglévő személyhez<br /><small>{{ jubTalalat.nev }}<span *ngIf="jubTalalat.szuletesi_ido"> · {{ jubTalalat.szuletesi_ido }}</span> — csak az üres mezőket egészíti ki</small></ion-label>
        </ion-item>
        <ion-item *ngIf="jubCelSzemelyId && !jubTalalat">
          <ion-radio slot="start" value="meglevo"></ion-radio>
          <ion-label>A megnyitott személyhez<br /><small>{{ jubParsed.nev }} — csak az üres mezőket egészíti ki</small></ion-label>
        </ion-item>
        <ion-item>
          <ion-radio slot="start" value="uj"></ion-radio>
          <ion-label>Új személy létrehozása</ion-label>
        </ion-item>
      </ion-radio-group>

      <ion-list class="ion-margin-top">
        <ion-item><ion-input label="Név" labelPlacement="stacked" [(ngModel)]="jubParsed.nev"></ion-input></ion-item>
        <ion-item><ion-input label="Születési név" labelPlacement="stacked" [(ngModel)]="jubParsed.szuletesi_nev"></ion-input></ion-item>
        <ion-item><ion-input label="Születési hely" labelPlacement="stacked" [(ngModel)]="jubParsed.szuletesi_hely"></ion-input></ion-item>
        <ion-item><ion-input type="date" label="Születési idő" labelPlacement="stacked" [(ngModel)]="jubParsed.szuletesi_ido"></ion-input></ion-item>
        <ion-item><ion-input label="Anyja neve" labelPlacement="stacked" [(ngModel)]="jubParsed.anyja_neve"></ion-input></ion-item>
        <ion-item><ion-input label="Személyi azonosító" labelPlacement="stacked" [(ngModel)]="jubParsed.szemelyi_szam"></ion-input></ion-item>
        <ion-item><ion-input label="Állampolgárság" labelPlacement="stacked" [(ngModel)]="jubParsed.allampolgarsag"></ion-input></ion-item>
      </ion-list>

      <ion-list-header><ion-label>Címek</ion-label></ion-list-header>
      <ion-list lines="full">
        <ion-item *ngIf="!jubParsed.cimek?.length"><ion-label color="medium">Nincs cím a PDF-ben.</ion-label></ion-item>
        <ion-item *ngFor="let c of jubParsed.cimek; let i = index">
          <ion-label><h3>{{ cimke(opciok.cimTipus, c.tipus) }}</h3><p>{{ c.cim }}</p></ion-label>
          <ion-button slot="end" fill="clear" color="danger" (click)="jubCimTorol(i)"><ion-icon name="trash"></ion-icon></ion-button>
        </ion-item>
      </ion-list>

      <ion-list-header><ion-label>Okmányok</ion-label></ion-list-header>
      <ion-list lines="full">
        <ion-item *ngIf="!jubParsed.okmanyok?.length"><ion-label color="medium">Nincs okmány a PDF-ben.</ion-label></ion-item>
        <ion-item *ngFor="let o of jubParsed.okmanyok; let i = index">
          <ion-label><h3>{{ cimke(opciok.okmanyTipus, o.tipus) }}</h3><p>{{ o.szam }}<span *ngIf="o.ervenyesseg"> · érv.: {{ o.ervenyesseg }}</span></p></ion-label>
          <ion-button slot="end" fill="clear" color="danger" (click)="jubOkmanyTorol(i)"><ion-icon name="trash"></ion-icon></ion-button>
        </ion-item>
      </ion-list>

      <ion-item lines="none" class="ion-margin-top">
        <ion-icon slot="start" name="shield-checkmark" color="primary"></ion-icon>
        <ion-label><h3>JÜB rekord</h3><p>{{ jubParsed.jub?.azonosito || '(azonosító nélkül)' }} · {{ jubParsed.jub?.datum }}</p></ion-label>
      </ion-item>

      <ion-button expand="block" class="ion-margin-top" (click)="jubPdfMentes()">
        <ion-icon slot="start" name="save"></ion-icon>{{ jubCel === 'uj' ? 'Új személy létrehozása + JÜB' : 'Mentés a személyhez + JÜB' }}
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- JÜB tömeges feldolgozás eredménye -->
<ion-modal #jubBulkModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Tömeges JÜB eredmény</ion-title>
        <ion-buttons slot="end"><ion-button (click)="jubBulkModal.dismiss()">Bezár</ion-button></ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium">{{ jubBulkEredmeny?.length || 0 }} fájl feldolgozva.</ion-note>
      <ion-list lines="full">
        <ion-item *ngFor="let e of jubBulkEredmeny">
          <ion-icon slot="start" [name]="e.hiba ? 'alert-circle' : (e.created ? 'person-add' : 'person')" [color]="e.hiba ? 'danger' : 'success'"></ion-icon>
          <ion-label>
            <h3>{{ e.nev || e.fajl }}</h3>
            <p *ngIf="!e.hiba">{{ e.fajl }} · {{ e.created ? 'új személy' : 'meglévőhöz társítva' }}</p>
            <p *ngIf="e.hiba" color="danger">{{ e.fajl }} — {{ e.hiba }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>
